import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Button, Menu, Segment, Tab, Table } from "semantic-ui-react";
import AppMenu from "../../components/pages/AppMenu";
import api from "../../api";
import settings from "../../settings";
import CurrentCases from "./CurrentCases";
import CaseActivities from "./CaseActivities";
import Case from "../dialogs/Case";
import { getMySearchesBreadcrumb } from "../common/Breadcrumb";
import PricingDetails from "./PricingDetails";
import PickUserForm from "../forms/PickUserForm";

class MyCases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentCase: null,
      currentCaseView: "list",
      showCaseDialog: false,
      loading: false,
      pickuser: undefined,
      activeIndex: 0,
    };
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  onLoadStart = () => {
    this.setState({ loading: true });
  };

  onLoadComplete = () => {
    this.setState({ loading: false });
  };

  dialogClose = () => {
    this.setState({ showCaseDialog: false });
  };

  showCase = () => {
    this.setState({ showCaseDialog: true });
  };

  handleTabChange = (e, { activeIndex }) => {
    this.setState({ activeIndex });
  };

  deleteCase = () => {
    this.onLoadStart();
    const params = {
      sserver: settings.appName,
      usercode: this.props.user.userid,
      folderCode: this.state.currentCase.folderCode,
      folderName: this.state.currentCase.folderName,
      deleteFolder: true,
      sessionID: localStorage.getItem("sessionID"),
    };
    api.lp
      .processCases(params)
      .then((res) => {
        if (res !== undefined && res.errors !== undefined) {
          if (_.get(res, "errors.error.errType") === "unauthorized") {
            localStorage.errorMessage = _.get(res, `errors.error.errMsg._`, "");
            this.props.expireSession();
          }
        } else {
          this.setState({
            currentCaseView: "list",
          });
        }
        this.onLoadComplete();
      })
      .catch((err) => console.log("load case view activities error - ", err));
  };

  updateCase = (currentCase) => {
    this.setState({ currentCase });
    this.viewCaseActivitiesPane();
  };

  viewCaseActivitiesPane = () => {
    this.setState({
      currentCaseView: "folder",
    });
  };

  updateCaseActivitiesPane = () => {
    this.setState({ currentCaseView: "folderedit" });
  };

  updateCasePricing = () => {
    this.setState({ currentCaseView: "editCasePricing" });
  };

  listFolders = () => {
    this.setState({ currentCaseView: "list" });
  };

  isCompMounted = false;

  editCase = (currentCase) => {
    this.setState({ currentCase, currentCaseView: "view" });
  };

  submit = (data) => {
    this.setState({ pickuser: data.pickuser, currentCaseView: "list" });
  };

  render() {
    const tabs = [];
    const { activeIndex } = this.state;
    const { acctTheme } = this.props.userAccount;
    tabs.push({
      menuItem:
        acctTheme === 0 ? (
          <Menu.Item
            key={`Tab_CurrentCases`}
            style={{
              fontSize: "12px",
              borderRadius: "10px 10px 0 0 !important",
            }}
            className={
              activeIndex === 0
                ? "classicTab selected_background"
                : "classicTab form_tab_unselected"
            }
          >
            Current Cases
          </Menu.Item>
        ) : (
          "Current Cases"
        ),
      render: () => (
        <Tab.Pane>
          <div>
            <div className="float-left medium-font">
              Searches conducted within 7 days can be viewed under My Searches
              without incurring additional cost. After 7 days the results will
              no longer be available. Search will need to be run again if
              needed, possible charges will be incurred
            </div>
            <div className={"padding-bottom-10 padding-right-20 float-right"}>
              <Button onClick={this.showCase}>Add New Case</Button>
            </div>
          </div>
          {this.state.currentCaseView === "list" ? (
            <CurrentCases
              {...this.props}
              editCase={this.editCase}
              onLoadStart={this.onLoadStart}
              onLoadComplete={this.onLoadComplete}
              pickuser={this.state.pickuser}
            />
          ) : (
            <div className="text-bold">
              <div className="padding-bottom-10">
                <br />
                <h3> {`Edit Case: ${this.state.currentCase.folderName}`} </h3>
              </div>
              <CaseActivities
                {...this.props}
                caseView={this.state.currentCaseView}
                currentCase={this.state.currentCase}
                updateCaseActivitiesPane={this.updateCaseActivitiesPane}
                updateCasePricing={this.updateCasePricing}
                listFolders={this.listFolders}
                deleteCase={this.deleteCase}
                viewCaseActivitiesPane={this.viewCaseActivitiesPane}
                onLoadStart={this.onLoadStart}
                onLoadComplete={this.onLoadComplete}
                pickuser={this.state.pickuser}
              />
            </div>
          )}
        </Tab.Pane>
      ),
    });

    tabs.push({
      menuItem:
        acctTheme === 0 ? (
          <Menu.Item
            key={`Tab_Pricing`}
            style={{
              fontSize: "12px",
              borderRadius: "10px 10px 0 0 !important",
            }}
            className={
              activeIndex === 1
                ? "classicTab selected_background"
                : "classicTab form_tab_unselected"
            }
          >
            Pricing
          </Menu.Item>
        ) : (
          "Pricing"
        ),
      render: () => (
        <Tab.Pane>
          <PricingDetails {...this.props} pickuser={this.state.pickuser} />
        </Tab.Pane>
      ),
    });
    return (
      <div className="container-fluid padding-top-20" id={"caseSection"}>
        <div className="padding-top-20" />
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
        />
        <div>
          <Segment
            loading={this.state.loading}
            className={"background-color-white"}
          >
            {getMySearchesBreadcrumb({
              currentPage: settings.myAccountMenuItem.subMenuItems[1].MenuTitle,
              history: this.props.history,
            })}
            <br />
            {this.props.userAccount.acctPickUser === "1" && (
              <Table>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <PickUserForm submit={this.submit} />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            )}
            <Tab
              panes={tabs}
              className="medium-font"
              activeIndex={activeIndex}
              onTabChange={this.handleTabChange}
            />
            <Case
              dialogProps={{
                title: "New Case",
                data: null,
              }}
              active={this.state.showCaseDialog}
              dialogClose={this.dialogClose}
              updateCase={this.updateCase}
              persistCaseSelection
            />
          </Segment>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    uiData: state.uiData,
    user: state.user,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(MyCases);



// WEBPACK FOOTER //
// ./src/components/myaccount/MyCases.js